import React from 'react';

interface IframeContentProps {
  src: string;
  title: string;
  className?: string;
  height?: string;
  width?: string;
}

export const IframeContent: React.FC<IframeContentProps> = ({
  src,
  title,
  className,
  height,
  width
}) => {
  return (
    <iframe
      className={className}
      style={{
        height: height ?? '60vh',
        width: width ?? '100%'
      }}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      src={src}
      title={title}
      allowFullScreen
    />
  );
};
